import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import strings from 'owa-strings/owa-common-strings';

export default function getRecipientString(recipientType: RecipientType) {
    switch (recipientType) {
        case RecipientType.To:
            return strings.ToRecipientLabel;
        case RecipientType.Cc:
            return strings.CcRecipientLabel;
        case RecipientType.Bcc:
            return strings.BccRecipientLabel;
        default:
            throw new Error(
                `There is no localized string for RecipientType.${RecipientType[recipientType]}`
            );
    }
}
